export default {
  updateFilter(state, filter) {
    state.filter = { ...filter }
  },
  refreshFilter(state, _pl) {
    state.filter = { ...state.filter }
  },
  addChannels(state, channels) {
    state.channels = channels
  },
  addDepartments(state, departments) {
    state.departments = departments
  },
  addUserLocations(state, locations) {
    state.user.locations = locations;
  },
  setApplicationMonths(state, payload) {
    const { months, complete } = payload
    state.applicationMonths.months = months
    state.applicationMonths.complete = complete
  },
  updateCounts(state, response) {
    state.sampleSize.totalCount = response.total_count
    state.sampleSize.myCount = response.my_count
    state.sampleSize.includeOld = response.include_old
    state.sampleSize.companyCount = response.company_count

    state.CxpSize.myCount = response.cxp_my_count
    state.CxpSize.totalCount = response.cxp_total_count
    state.CxpSize.companyCount = response.cxp_company_count

    state.returnRates = response.return_rates
  },
}
